export class Utils {
    public static emailValid(email: string): boolean {
        return email.includes("@") &&
            email.includes(".") &&
            !email.includes(".@") &&
            !email.includes("@.") &&
            email[email.length - 1] !== "."
    }
}
